import {BaseLayerDeck} from './baseLayerDeck';


export abstract class BaseLayerGeoJSONDeck extends BaseLayerDeck {
    protected constructor(id) {
        super(id);
    }

    getEmptySource() {
        return {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Point',
                        coordinates: []
                    }
                }
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/common/layers/baseLayerGeoJSONDeck.ts